import * as ActionConfigurationManager from './config.actions';

export const savePlan = ActionConfigurationManager.SAVE_PLAN;
export const rehydratePlan = ActionConfigurationManager.REHYDRATE_PLAN;
export const commercialPlan = ActionConfigurationManager.COMMERCIAL_PLAN;
export const savePlanRatesPage = ActionConfigurationManager.SAVE_PLAN_RATES_PAGE;



